import { makeVar } from '@apollo/client';

type SignInState = {
  isSignedIn: boolean;
  isAlreadySignedInOnce: boolean;
  isStudentSignedIn: boolean;
};

export const signInStateVar = makeVar<SignInState>({
  isSignedIn: false,
  isAlreadySignedInOnce: false,
  isStudentSignedIn: false,
});
